import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import audio.WebSoundEngine
import domain.player.PlayerSession
import kotlinx.browser.document
import storage.LocalStoragePlayerProfileRepository

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    PlayerSession.repository = LocalStoragePlayerProfileRepository()
    ComposeViewport(document.body!!) {
        GravitarApp(soundEngine = WebSoundEngine())
    }
}
